import React, { useEffect, useState } from 'react';
import SiriusModal from '@web-common/components/UI/Modal/SiriusModal';
import Checkbox from '@lingxi-common-component/sirius-ui/Checkbox';
import style from './style.module.scss';
import { useActions, MailProductActions, useAppSelector } from '@web-common/state/createStore';
import toast from '@web-common/components/UI/Message/SiriusMessage';
import { apiHolder, apis, getIn18Text } from 'api';
const trackApi = apiHolder.api.requireLogicalApi(apis.dataTrackerApiImp);
const CheckboxGroup = Checkbox.Group;
const MAX_COUNT = [4, 8, 4];
export const OtherColorOptions = [
    {
        value: 'color',
        label: '颜色',
        en: `Color`,
        cn: `颜色`,
        jp: `色`,
        de: `Farbe`,
        fr: `Couleur`,
        ru: `Цвет`,
        pt: `Cor`,
        es: `Color`,
        po: `Kolor`,
        hin: `रंग`,
        ar: `لون`,
        bn: `রঙ`,
        ur: `رنگ`,
        id: `Warna`,
        tr: `Renk`,
        tam: `நிறம்`,
        vi: `Màu sắc`,
        fa: `رنگ`,
        zu: `Umbala`,
        ko: `색상`,
        uz: `Rang`,
        tc: `顏色`,
        it: `Colore`,
    },
];
export const ProductAttrOptions = [
    {
        value: 'specificationInfo',
        label: '商品规格',
        en: 'Product Specification',
        cn: '商品规格',
        jp: '商品規格',
        de: 'Produktspezifikation',
        fr: 'Spécification du produit',
        ru: 'Спецификация товара',
        pt: 'Especificação do produto',
        es: 'Especificación del producto',
        po: 'Specyfikacja produktu',
        hin: 'उत्पाद विनिर्देश',
        ar: 'محددات المنتج',
        bn: 'পণ্যের স্পেসিফিকেশন',
        ur: 'پروڈکٹ کی وضاحت',
        id: 'Spesifikasi Produk',
        tr: 'Ürün Ölçüsü',
        tam: 'தயாரிப்பு விவரங்கள்',
        vi: 'Thông số sản phẩm',
        fa: 'مشخصات محصول',
        zu: 'Ukulungiselela komkhulu',
        ko: '제품 규격',
        uz: 'Mahsulot belgisi',
        tc: '商品規格',
        it: 'Specifiche del prodotto',
    },
    {
        value: 'product_name_en',
        label: '商品英文名',
        en: `Product Name`,
        cn: `商品英文名`,
        jp: `商品名`,
        de: `Produktname`,
        fr: `Nom du produit`,
        ru: `Название продукта`,
        pt: `Nome do produto`,
        es: `Nombre del producto`,
        po: `Nazwa produktu`,
        hin: `उत्पाद का नाम`,
        ar: `اسم المنتج`,
        bn: `পণ্যের নাম`,
        ur: `پروڈکٹ کا نام`,
        id: `Nama Produk`,
        tr: `Ürün Adı`,
        tam: `தயாரிப்பு பெயர்`,
        vi: `Tên sản phẩm`,
        fa: `نام محصول`,
        zu: `Igama lomkhiqizo`,
        ko: `제품 이름`,
        uz: `Mahsulot nomi`,
        tc: `商品名稱`,
        it: `Nome del prodotto`,
    },
    {
        value: 'product_name_cn',
        label: '商品中文名',
        en: `Product Name`,
        cn: `商品中文名`,
        jp: `商品名`,
        de: `Produktname`,
        fr: `Nom du produit`,
        ru: `Название продукта`,
        pt: `Nome do produto`,
        es: `Nombre del producto`,
        po: `Nazwa produktu`,
        hin: `उत्पाद का नाम`,
        ar: `اسم المنتج`,
        bn: `পণ্যের নাম`,
        ur: `پروڈکٹ کا نام`,
        id: `Nama Produk`,
        tr: `Ürün Adı`,
        tam: `தயாரிப்பு பெயர்`,
        vi: `Tên sản phẩm`,
        fa: `نام محصول`,
        zu: `Igama lomkhiqizo`,
        ko: `제품 이름`,
        uz: `Mahsulot nomi`,
        tc: `商品名稱`,
        it: `Nome del prodotto`,
    },
    {
        value: 'product_number',
        label: '商品编号',
        en: `Product Number`,
        cn: `商品编号`,
        jp: `商品番号`,
        de: `Produktnummer`,
        fr: `Numéro de produit`,
        ru: `Номер продукта`,
        pt: `Número do produto`,
        es: `Número de producto`,
        po: `Numer produktu`,
        hin: `उत्पाद संख्या`,
        ar: `رقم المنتج`,
        bn: `পণ্যের সংখ্যা`,
        ur: `پروڈکٹ نمبر`,
        id: `Nomor Produk`,
        tr: `Ürün Numarası`,
        tam: `தயாரிப்பு எண்`,
        vi: `Số sản phẩm`,
        fa: `شماره محصول`,
        zu: `Umkhiqizo inombolo`,
        ko: `제품 번호`,
        uz: `Mahsulot raqami`,
        tc: `商品編號`,
        it: `Numero del prodotto`,
    },
    {
        value: 'moq',
        label: '起订量',
        en: `Minimum Order Quantity`,
        cn: `起订量`,
        jp: `最小注文数量`,
        de: `Mindestbestellmenge`,
        fr: `Quantité de commande minimale`,
        ru: `Минимальное количество заказа`,
        pt: `Quantidade mínima de pedido`,
        es: `Cantidad mínima de pedido`,
        po: `Minimalna ilość zamówienia`,
        hin: `न्यूनतम आदेश मात्रा`,
        ar: `الحد الأدنى للطلب`,
        bn: `ন্যূনতম অর্ডার পরিমাণ`,
        ur: `کم از کم آرڈر کی مقدار`,
        id: `Jumlah Pesanan Minimum`,
        tr: `Minimum Sipariş Miktarı`,
        tam: `குறைந்தபட்ச ஆர்டர் அளவு`,
        vi: `Số lượng đặt hàng tối thiểu`,
        fa: `حداقل مقدار سفارش`,
        zu: `Okuncane kokubhalwa`,
        ko: `최소 주문 수량`,
        uz: `Minimal buyurtma miqdori`,
        tc: `起訂量`,
        it: `Quantità minima d'ordine`,
    },
    {
        value: 'price',
        label: '销售价',
        en: `Selling Price`,
        cn: `销售价`,
        jp: `販売価格`,
        de: `Verkaufspreis`,
        fr: `Prix de vente`,
        ru: `Цена продажи`,
        pt: `Preço de venda`,
        es: `Precio de venta`,
        po: `Cena sprzedaży`,
        hin: `बिक्री मूल्य`,
        ar: `سعر البيع`,
        bn: `বিক্রয় মূল্য`,
        ur: `فروخت کی قیمت`,
        id: `Harga Jual`,
        tr: `Satış Fiyatı`,
        tam: `விற்பனை விலை`,
        vi: `Giá bán`,
        fa: `قیمت فروش`,
        zu: `Intengo yokuthengisa`,
        ko: `판매 가격`,
        uz: `Sotish narxi`,
        tc: `銷售價`,
        it: `Prezzo di vendita`,
    },
    {
        value: 'packaging_count',
        label: '每件数量',
        en: `Quantity per Item`,
        cn: `每件数量`,
        jp: `アイテムごとの数量`,
        de: `Menge pro Artikel`,
        fr: `Quantité par article`,
        ru: `Количество на единицу`,
        pt: `Quantidade por item`,
        es: `Cantidad por artículo`,
        po: `Ilość na przedmiot`,
        hin: `प्रति आइटम मात्रा`,
        ar: `الكمية لكل عنصر`,
        bn: `প্রতি আইটেম পরিমাণ`,
        ur: `ہر آئٹم کی مقدار`,
        id: `Jumlah per Item`,
        tr: `Her Ürün İçin Miktar`,
        tam: `ஒவ்வொரு உருப்படியும் அளவு`,
        vi: `Số lượng mỗi mặt hàng`,
        fa: `مقدار در هر مورد`,
        zu: `Inani ngempahla ngayinye`,
        ko: `항목당 수량`,
        uz: `Har bir mahsulot uchun miqdor`,
        tc: `每件數量`,
        it: `Quantità per articolo`,
    },
    {
        value: 'shipping_method',
        label: '物流方式',
        en: `Shipping Method`,
        cn: `物流方式`,
        jp: `配送方法`,
        de: `Versandart`,
        fr: `Méthode d'expédition`,
        ru: `Способ доставки`,
        pt: `Método de envio`,
        es: `Método de envío`,
        po: `Metoda wysyłki`,
        hin: `शिपिंग विधि`,
        ar: `طريقة الشحن`,
        bn: `শিপিং পদ্ধতি`,
        ur: `شپنگ کا طریقہ`,
        id: `Metode Pengiriman`,
        tr: `Gönderim Yöntemi`,
        tam: `கப்பல் முறை`,
        vi: `Phương thức vận chuyển`,
        fa: `روش حمل و نقل`,
        zu: `Indlela yokuthumela`,
        ko: `배송 방법`,
        uz: `Yuk tashish usuli`,
        tc: `物流方式`,
        it: `Metodo di spedizione`,
    },
    {
        value: 'volume',
        label: '体积',
        en: `Volume`,
        cn: `体积`,
        jp: `体積`,
        de: `Volumen`,
        fr: `Volume`,
        ru: `Объем`,
        pt: `Volume`,
        es: `Volumen`,
        po: `Objętość`,
        hin: `आकार`,
        ar: `حجم`,
        bn: `আয়তন`,
        ur: `حجم`,
        id: `Volume`,
        tr: `Hacim`,
        tam: `அளவு`,
        vi: `Thể tích`,
        fa: `حجم`,
        zu: `Ivolumu`,
        ko: `부피`,
        uz: `Hajm`,
        tc: `體積`,
        it: `Volume`,
    },
    {
        value: 'gross_weight',
        label: '单毛重',
        en: `Gross Weight`,
        cn: `单毛重`,
        jp: `総重量`,
        de: `Bruttogewicht`,
        fr: `Poids brut`,
        ru: `Брутто вес`,
        pt: `Peso bruto`,
        es: `Peso bruto`,
        po: `Waga brutto`,
        hin: `सकल वजन`,
        ar: `الوزن الإجمالي`,
        bn: `মোট ওজন`,
        ur: `مکمل وزن`,
        id: `Berat Kotor`,
        tr: `Brüt Ağırlık`,
        tam: `மொத்த எடை`,
        vi: `Khối lượng tổng`,
        fa: `وزن ناخالص`,
        zu: `Isisindo esiphelele`,
        ko: `총 중량`,
        uz: `Jami og'irlik`,
        tc: `單毛重`,
        it: `Peso lordo`,
    },
    {
        value: 'net_weight',
        label: '单净重',
        en: `Net Weight`,
        cn: `单净重`,
        jp: `正味重量`,
        de: `Nettogewicht`,
        fr: `Poids net`,
        ru: `Чистый вес`,
        pt: `Peso líquido`,
        es: `Peso neto`,
        po: `Waga netto`,
        hin: `शुद्ध वजन`,
        ar: `الوزن الصافي`,
        bn: `নিট ওজন`,
        ur: `خالص وزن`,
        id: `Berat Bersih`,
        tr: `Net Ağırlık`,
        tam: `சுத்த எடை`,
        vi: `Khối lượng tịnh`,
        fa: `وزن خالص`,
        zu: `Isisindo esicacile`,
        ko: `순 중량`,
        uz: `Sof og'irlik`,
        tc: `單淨重`,
        it: `Peso netto`,
    },
    {
        value: 'product_description_en',
        label: '商品介绍（英文）',
        en: `Product Description`,
        cn: `商品介绍（英文）`,
        jp: `商品説明`,
        de: `Produktbeschreibung`,
        fr: `Description du produit`,
        ru: `Описание продукта`,
        pt: `Descrição do produto`,
        es: `Descripción del producto`,
        po: `Opis produktu`,
        hin: `उत्पाद विवरण`,
        ar: `وصف المنتج`,
        bn: `পণ্যের বিবরণ`,
        ur: `پروڈکٹ کی تفصیل`,
        id: `Deskripsi Produk`,
        tr: `Ürün Açıklaması`,
        tam: `தயாரிப்பு விளக்கம்`,
        vi: `Mô tả sản phẩm`,
        fa: `شرح محصول`,
        zu: `Incazelo yomkhiqizo`,
        ko: `제품 설명`,
        uz: `Mahsulot tavsifi`,
        tc: `商品介紹`,
        it: `Descrizione del prodotto`,
    },
];
export const ProductUpdateColumnModal = (props) => {
    const imgColumns = useAppSelector(state => state.mailProductReducer.imgColumns);
    const tableColumns = useAppSelector(state => state.mailProductReducer.tableColumns);
    const waColumns = useAppSelector(state => state.mailProductReducer.waColumns);
    const themeColumns = [imgColumns, tableColumns, waColumns];
    const columns = themeColumns[props.theme];
    const maxCount = MAX_COUNT[props.theme];
    const actualMaxCount = props.theme == 2 ? maxCount + 1 : maxCount;
    const isInWAPage = props.fromPage === 'WA';
    useEffect(() => {
        setKeys(themeColumns[props.theme]);
    }, [imgColumns, tableColumns, props.theme]);
    const [keys, setKeys] = useState(columns);
    const { updateImgColumns, updateTableColumns, updateWAColumns } = useActions(MailProductActions);
    const onChange = (value) => {
        let _maxCount = props.theme == 2 ? maxCount + 1 : maxCount;
        if (value.length > _maxCount) {
            toast.error({ content: getIn18Text('ZUIDUOKEXUANZEXGE', { count: maxCount }) });
        }
        else {
            const sortedCheckedValues = ProductAttrOptions.filter(option => value.includes(option.value)).map(option => option.value);
            setKeys(sortedCheckedValues);
        }
    };
    const onOk = () => {
        if (keys.length === 0) {
            toast.error({ content: getIn18Text('QINGXUANZEZIDUAN') });
            return;
        }
        if (props.theme === 0) {
            updateImgColumns(keys);
        }
        else if (props.theme === 1) {
            updateTableColumns(keys);
        }
        else {
            updateWAColumns(keys);
        }
        props.onClose();
        trackApi.track('product_select__click_confirm', { from_page: props.fromPage, action: 'modify_display' });
    };
    const onCancel = () => {
        setKeys(columns);
        props.onClose();
    };
    return (React.createElement(SiriusModal, { title: getIn18Text('XIUGAIZIDUAN'), width: 545, maskClosable: false, visible: props.visible, className: style.productUpdateColumnModal, onCancel: onCancel, onOk: onOk, getContainer: document.body },
        React.createElement("div", { className: style.tip },
            props.theme === 1 ? getIn18Text('BIAOGE') : getIn18Text('TUWEN'),
            getIn18Text('YANGSHIZUIDUOZHICHI'),
            maxCount,
            getIn18Text('GEZIDUAN')),
        React.createElement("div", { className: style.content },
            React.createElement("div", { className: style.title }, getIn18Text('ZHANSHIZIDUAN：')),
            isInWAPage ? (React.createElement(CheckboxGroup, { value: keys, onChange: onChange }, ProductAttrOptions.filter(item => item.value !== 'specificationInfo')
                .concat(OtherColorOptions)
                .map((item, index) => {
                const firstColumnDisable = props.theme == 2 && index == 0;
                const exceedLimit = keys.length >= actualMaxCount && !keys.includes(item.value);
                return (React.createElement(Checkbox, { key: item.value, value: item.value, disabled: firstColumnDisable || exceedLimit }, item.label));
            }))) : (React.createElement(CheckboxGroup, { value: keys, onChange: onChange }, ProductAttrOptions.map((item, index) => {
                const firstColumnDisable = props.theme == 2 && index == 0;
                const exceedLimit = keys.length >= actualMaxCount && !keys.includes(item.value);
                return (React.createElement(Checkbox, { key: item.value, value: item.value, disabled: firstColumnDisable || exceedLimit }, item.label));
            }))))));
};
